import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { marked } from 'marked';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[marked]',
    standalone: true,
})
export class MarkedDirective implements OnChanges {
    @Input('marked') markedContent: string | undefined;

    constructor(private el: ElementRef<HTMLElement>) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.markedContent?.currentValue) {
            this.el.nativeElement.innerHTML = marked(this.markedContent || '');
        }
    }
}
